// Systemeinstellung „Bewegung reduzieren“: dann keine automatisch laufenden Karussells und kein weiches Scrollen
export const REDUCED_MOTION =
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Intervall für react-bootstrap-Karussells: null = kein automatischer Wechsel
export const karussellIntervall = (ms) => (REDUCED_MOTION ? null : ms);
